/** org group: organisation settings, links and accounting periods (tenancy) (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const orgPermissions = ['org:read', 'org:manage', 'org:links:manage', 'org:periods:lock'] as const;

export type OrgGroupPermission = (typeof orgPermissions)[number];
